import apiClient from './api';

const SESSION_KEY = 'zaynic_chat_session_id';

class ChatService {
    static readStoredSessionId() {
        try {
            return localStorage.getItem(SESSION_KEY) || null;
        } catch {
            return null;
        }
    }

    static persistSessionId(sessionId) {
        if (!sessionId) return;
        try {
            localStorage.setItem(SESSION_KEY, sessionId);
        } catch {
            /* ignore */
        }
    }

    static clearSession() {
        try {
            localStorage.removeItem(SESSION_KEY);
        } catch {
            /* ignore */
        }
    }

    static async sendMessage(message, { sessionId, signal } = {}) {
        try {
            const body = { message };
            if (sessionId) body.session_id = sessionId;
            const response = await apiClient.post('/chat/', body, { signal });
            return { success: true, data: response.data };
        } catch (error) {
            console.error('Chat error:', error);
            return {
                success: false,
                error: error.response?.data?.detail || 'Failed to send message'
            };
        }
    }
}

export default ChatService;
